import React from 'react';
import classnames from 'classnames';
import LocalizedMessage from 'react-l10n';

/**
 * Notice Box
 *
 * @param props
 * @returns {*}
 * @constructor
 *
 * Usage example:
    <NoticeBox
        type={'error'}
        icon={'icon-warning'}
        content={(
            <p>The details entered have not been validated. Please check your information and click retry</p>
        )}
        retryActions={(
            <a href="#" className="button">
                <span className="icon icon-refresh"></span>
                <span>Retry</span>
            </a>
        )}
        proceedActions={(
            <a href="#" className="button">
                <span className="icon icon-refresh"></span>
                <span>Proceed</span>
            </a>
        )}
    />
 */
function NoticeBox(props) {
    const { id, type, icon, content, retryActions, proceedActions } = props;

    const getBoxedMessageClassName = () => {
        if (!type) {
            return null;
        }

        switch (type.toLowerCase()) {
            case 'warning':
            case 'yellow':
                return 'react-notice-box--yellow';
            case 'error':
            case 'red':
                return 'react-notice-box--red';
            case 'info':
            case 'blue':
                return 'react-notice-box--blue';
            case 'success':
            case 'green':
                return 'react-notice-box--green';
        }

        return null;
    };

    const getNoticeBoxProps = () => {
        let props = {
            className: classnames(
                'react-notice-box',
                getBoxedMessageClassName(),
                icon && 'react-notice-box--icon'
            ),
        };

        if (id) {
            props = {
                ...props,
                id: id,
            };
        }

        return props;
    };

    return (
        <div {...getNoticeBoxProps()}>
            <div className='react-notice-box__content-area'>
                {icon && (
                    <div className='react-notice-box__icon-area'>
                        <span className={classnames('icon', icon)} />
                    </div>
                )}
                <div className='react-notice-box__content'>{content}</div>
            </div>
            {retryActions && (
                <React.Fragment>
                    <div className='react-notice-box__action-area'>
                        {retryActions}
                    </div>
                </React.Fragment>
            )}
            {proceedActions && (
                <React.Fragment>
                    <div className='react-notice-box__action-area'>
                        {proceedActions}
                    </div>
                </React.Fragment>
            )}
        </div>
    );
}

export default NoticeBox;
